export default {
      id: "rush-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#rush",
      toString: function () {
        return this.url;
      }
    }